import { AdminSettings } from '@/features/admin/settings/AdminSettings';

export function AdminSettingsPage() {
  return (
    <div className="h-full overflow-y-auto bg-background">
      <div className="p-6 space-y-6">
        <AdminSettings />
      </div>
    </div>
  );
}
